import React, { useState } from 'react'

const Welcome = ({ startRating }) => {
    const [ input, setInput ] =  useState("")
    const [ testMessage, setTestMessage ] = useState("Secret message incoming...")
    const [ counter, setCounter ] = useState(2)

    const handleInputChange = e => {
        setInput(e.target.value)
    }

    
  const sendSomeData = () => {
        fetch(".netlify/functions/mini_post", {
            method: "post",
            body: JSON.stringify(testMessage)
        })
            .then(r => r.json())
            .then(setNewMessage)
            .catch(console.log)
        
    }

    const setNewMessage = secret => {
        console.log(secret)
        const newCount = counter + 1
        setCounter(newCount)
        const newMessage = `Secret message ${counter} incoming...`
        setTestMessage(newMessage)
    }

    return (
        <div>   
            <h1 id="logo-text" onClick={sendSomeData}>Zero to Hero</h1>
            <p>Rate five heroes based on instinct <br className="portrait-wrap"/>and we will tell you your ideal Hero!</p>
            <form onSubmit={e => startRating(input, e)}>
                <label>Name</label><input type="text" onChange={handleInputChange} value={input} placeholder="What is your name?"/>
                <input type="submit" value="Start"/>
            </form>
        </div>
    )
}

export default Welcome
